import axios from "axios";
import { evaluateError, getAccessToken, processFailure } from "./auth";

const BASE_API_URL = process.env.VUE_APP_APIURL 
// const BASE_API_URL = "https://apiuatv2.winwinstafflottery.ca/api/v1" 


export async function apiGetAsync(
	url,
	token,
	urlPrefix,
	continuation,
	administration
) {
	// const token = await getAccessToken();
	const recaptchaToken = await getRecaptcha();

	const target = `${BASE_API_URL}` + url;
	const headers = { "X-SQ-Continuation": continuation };
	headers.Authorization = "Bearer " + token;
	headers["smc-recaptcha-token"] = recaptchaToken;

	try {
		const getResponse = await axios.get(target, {
			cache: false,
			headers,
			crossDomain: true,
			dataType: "json",
			contentType: "application/json",
		});
		evaluateError(getResponse.data);
		return getResponse.data;
	} catch (error) {
		console.warn(error);
	}
}

export async function apiPostAsync(url, data, urlPrefix, administration) {
	const token = await getAccessToken();
	const recaptchaToken = await getRecaptcha();

	const target = `${BASE_API_URL}` + url;
	const headers = {
		"Content-Type": "application/json",
	};
	headers.Authorization = "Bearer " + token;
	headers["smc-recaptcha-token"] = recaptchaToken;

	try {
		const postResponse = await axios.post(target, JSON.stringify(data), {
			crossDomain: true,
			dataType: "json",
			contentType: "application/json",
			headers,
		});
		evaluateError(postResponse.data);
		return postResponse.data;
	} catch (error) {
		console.warn(error);
	}
}

export async function apiPutAsync(url, data, urlPrefix) {
	const token = await getAccessToken();
	const recaptchaToken = await getRecaptcha();

	const target = `${BASE_API_URL}` + url;
	const headers = {
		"Content-Type": "application.json",
	};
	headers.Authorization = "Bearer " + token;
	headers["smc-recaptcha-token"] = recaptchaToken;

	try {
		const postResponse = await axios.put(target, JSON.stringify(data), {
			crossDomain: true,
			dataType: "json",
			contentType: "application/json",
			headers,
		});
		evaluateError(postResponse.data);
		return postResponse.data;
	} catch (error) {
		console.warn(error);
	}
}

export async function apiDeleteAsync(url, urlPrefix) {
	const token = await getAccessToken();
	const recaptchaToken = await getRecaptcha();

	const target = `${BASE_API_URL}` + url;
	const headers = {
		"Content-Type": "application/json",
	};
	headers.Authorization = "Bearer " + token;
	headers["smc-recaptcha-token"] = recaptchaToken;

	try {
		const getResponse = await axios.delete(target, {
			cache: false,
			headers,
			crossDomain: true,
			dataType: "json",
			contentType: "application/json",
		});
		evaluateError(getResponse.data);
		return getResponse.data;
	} catch (error) {
		console.warn(error);
	}
}

export function getAllParams() {
	let queryString = window.location.hash || window.location.search || "";
	let keyValuePairs = [];
	const params = {};
	queryString = queryString.replace(/.*?\?/, "");
	if (queryString.length) {
		keyValuePairs = queryString.split("&");
		for (const pairNum in keyValuePairs) {
			const key = keyValuePairs[pairNum].split("=")[0];
			if (!key.length) {
				continue;
			}
			if (typeof params[key] === "undefined") {
				params[key] = [];
			}
			params[key].push(keyValuePairs[pairNum].split("=")[1]);
		}
	}

	return params;
}

export function getRecaptcha() {
	return new Promise((resolve) => {
		grecaptcha.ready(function() {
			grecaptcha
				.execute("6LfHpBopAAAAADgfco-Tgaan4RKpYOd0_DmDpd8v", { action: "submit" })
				.then(function(token) {
					resolve(token);
				});
		});
	});
}
